import { TellescopeModelFromName } from "@tellescope/tanstack-query";
import { Dispatch, SetStateAction } from "react";
import { i18n } from "@tellescope/i18n";
import { createStore } from "@tellescope/store";

/** URL viewId used by `/tickets/views/:viewId` for the default tickets view. */
export const DEFAULT_TICKETS_VIEW_URL_ID = "default";

const getDefaultTitle = () => i18n.t("Default View", { ns: "tickets" });

export const DEFAULT_TICKETS_VIEW = {
  id: "default",
  businessId: "",
  updatedAt: new Date(0),
  creator: "",
  title: getDefaultTitle(),
  page: "Tickets",
  columns: [
    {
      field: "Details",
      type: "Built-In",
    },
    {
      field: "Description",
      type: "Built-In",
    },
    {
      field: "Created",
      type: "Built-In",
    },
    {
      field: "Stage",
      type: "Built-In",
    },
    {
      field: "Priority",
      type: "Built-In",
    },
    {
      field: "Due Date",
      type: "Built-In",
    },
    {
      field: "Owner",
      type: "Built-In",
    },
    {
      field: "Enduser",
      type: "Built-In",
    },
    {
      field: "Actions",
      type: "Built-In",
    },
    {
      field: "index",
      type: "Built-In",
    },
  ],
  createdAt: new Date(0),
} as const satisfies TellescopeModelFromName<"table_views">;

interface TicketsDefaultViewStore {
  defaultViewByUserId: Record<string, TellescopeModelFromName<"table_views">>;
  setUserDefaultView: (
    userId: string,
    newVal: Parameters<Dispatch<SetStateAction<TellescopeModelFromName<"table_views">>>>[0]
  ) => void;
  /** URL `:viewId` of the last `/tickets/views/:viewId` the user visited. */
  lastSelectedViewId: string;
  setLastSelectedViewId: (viewId: string) => void;
}

export const { useStore: useTicketsDefaultViewStore, useShallowStore: useTicketsDefaultViewShallowStore } =
  createStore<TicketsDefaultViewStore>(
    (set) => ({
      defaultViewByUserId: {},
      setUserDefaultView: (userId, newVal) =>
        set((state) => {
          const currentValue = state.defaultViewByUserId[userId] ?? DEFAULT_TICKETS_VIEW;

          const resolvedVal = typeof newVal === "function" ? newVal(currentValue) : newVal;

          return {
            ...state,
            defaultViewByUserId: {
              ...state.defaultViewByUserId,
              [userId]: resolvedVal,
            },
          };
        }),
      lastSelectedViewId: DEFAULT_TICKETS_VIEW_URL_ID,
      setLastSelectedViewId: (viewId) => set({ lastSelectedViewId: viewId }),
    }),
    {
      persist: "localStorage",
      name: "DEFAULT_TICKET_TABLE_VIEW",
    }
  );
